import React from 'react';
import './Home.css';
import Hello from '../components/Hello';

const Home: React.FC = () => {
  return (
    <div className="background-gradient home-page">
      <section className="section home-hero-section">
        <div className="container home-hero-container">
          <Hello />

          <div className="home-hero-scroll">
            <span className="home-hero-scroll__label">больше о проекте</span>
            <a className="home-hero-scroll__chevrons" href="#site-footer" aria-label="Перейти ниже по странице">
              <span className="home-hero-scroll__chevron" aria-hidden="true"></span>
              <span className="home-hero-scroll__chevron" aria-hidden="true"></span>
              <span className="home-hero-scroll__chevron" aria-hidden="true"></span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
